import { api } from '../api';

/**
 * Estado de la persona en el Reporte de padrón (VEN-512). Espejo de
 * `ReportePadronEstado` del server: los que dependen del legajo usan el mismo
 * valor de `legajo.estado`; los otros cuatro son marcas de la persona y las dos
 * mitades de un legajo bis.
 */
export type ReportePadronEstado =
  | 'bloqueado'
  | 'error'
  | 'pendiente_validacion_medicus'
  | 'creado'
  | 'en_validacion'
  | 'validado_por_titular'
  | 'en_alta_binary'
  | 'dado_de_alta'
  | 'rechazado_binary'
  | 'rechazado_medicus'
  | 'dado_de_baja'
  | 'espera_activacion_titular'
  | 'integrantes_a_sumar';

/** Una fila por persona del legajo: el titular y cada familiar. */
export interface ReportePadronRow {
  /** `_id` del legajo. Con `asociadoId` arma la `key` de la fila. */
  legajoId: string;
  asociadoId: string;
  legajo: string;
  dni: string;
  cuil: string;
  nombre: string;
  parentesco: string;
  estado: ReportePadronEstado;
  /** Nombre del estado tal como lo escribe el server (también en la descarga). */
  estadoLabel: string;
  /** Día de carga, aaaa-mm-dd. */
  fechaCarga: string | null;
}

export interface ReportePadronParams {
  estado?: ReportePadronEstado;
  /** Fecha de carga, aaaa-mm-dd (del `<input type="date">`). */
  fechaDesde?: string;
  fechaHasta?: string;
  empresaId?: string;
  dni?: string;
}

export interface ReportePadronPagina {
  items: ReportePadronRow[];
  /** Personas del filtro completo, no solo las de la página. */
  total: number;
  page: number;
  pageSize: number;
}

/** Filas por página. El server tiene su propio techo (200). */
export const REPORTE_PADRON_PAGE_SIZE = 25;

/**
 * Una página del reporte. Para bajar el universo completo del filtro está el
 * export async (`ExportModal` con tipo `reporte-padron`), no esta llamada.
 */
export async function getReportePadron(
  params: ReportePadronParams,
  page = 1,
  pageSize = REPORTE_PADRON_PAGE_SIZE,
): Promise<ReportePadronPagina> {
  const { data } = await api.get<ReportePadronPagina>('/legajos/reporte-padron', {
    params: { ...params, page, pageSize },
    // Sin esto axios espera para siempre (su default es 0).
    timeout: 60_000,
  });
  return data;
}
